import { supabase } from './supabase';
import type { SandboxPost, SandboxBadge } from '../types/sandbox';

type PostCallback = (post: SandboxPost) => void;
type BadgeCallback = (badge: SandboxBadge) => void;

export function subscribeToFeed(onNewPost: PostCallback) {
  const client = supabase;
  if (!client) return null;

  const channel = client
    .channel('sandbox-feed')
    .on(
      'postgres_changes',
      { event: 'INSERT', schema: 'public', table: 'sandbox_posts' },
      (payload) => {
        onNewPost(payload.new as SandboxPost);
      }
    )
    .subscribe();

  return () => {
    client.removeChannel(channel);
  };
}

export function subscribeToBadges(operatorDid: string, onBadge: BadgeCallback) {
  const client = supabase;
  if (!client) return null;

  const channel = client
    .channel(`badges-${operatorDid}`)
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'sandbox_badges',
        filter: `operator_did=eq.${operatorDid}`,
      },
      (payload) => {
        onBadge(payload.new as SandboxBadge);
      }
    )
    .subscribe();

  return () => {
    client.removeChannel(channel);
  };
}
